export const courseDeta = [
    {
        "name": "主要内容： ",
        "content": "在线中文课程内容包括拼音和识字。帮助学前儿童学习汉字和拼音，以及汉字的基本认知。",
    },
    // {
    //     "name": "Details:",
    //     "content": "The content of the Pinyin course: natural spelling, master the pronunciation and spelling of Pinyin;\nChinese character course content: Enlightenment of Chinese characters, understand the basic knowledge of Chinese characters, master commonly used Chinese characters, establish the concept of Chinese characters, and improve the ability to perceive Chinese characters.",
    // }
]
export const courseDeta2 = [
    {
        number: "01",
        color: "#4C9EE1",
        bagColor: "#E9F8FF",
        "content": "拼音发音、汉字读写、笔画、部首、日常交流和简单的生活场景描述。",
    },
    {
        number: "02",
        color: "#4540E1",
        bagColor: "#EFEFFF",
        "content": "提高口语能力，拓展词汇量，学习短语、短句的写作和表达，可以进行简短的对话，完成一篇200字的短文。",
    },
    {
        number: "03",
        color: "#FC9E5C",
        bagColor: "#FFF4EF",
        "content": "练习对话式阅读，培养图片分析能力，练习看图识字，培养在日常交流中使用高频词汇的习惯，提高阅读能力。",
    },
    {
        number: "04",
        color: "#FA8F80",
        bagColor: "#FDF0ED",
        "content": "提高阅读能力，能够运用日常词汇和句型构建中文思维逻辑，并讨论各种话题，初步建立一套完整的文章写作体系。",
    },
    {
        number: "05",
        color: "#C557CF",
        bagColor: "#FBF0FD",
        "content": "提高段落写作能力，能够完成400字的文章。能够建立中文的逻辑思维，完成主题阐述，并能根据写作和口语选择不同的表达方式。",
    },
    {
        number: "06",
        color: "#71E2A6",
        bagColor: "#F0FCF6 ",
        "content": "拓展丰富的词汇量，提高语言组织能力，并完成500字的作文。通过阅读讨论、视听材料分析和课堂互动，培养口语表达的自信心和技巧，为PSLE考试做好准备。",
    }
]
export const courseDeta3 = [
    {
        "title": "1对1定制课程",
        "picture": "../assets/singapore/why1.jpg"
    },
    {
        "title": "经验丰富的MOE师资团队",
        "picture": "../assets/singapore/why2.png"
    },
    {
        "title": "有趣的课堂内容",
        "picture": "../assets/singapore/why3.jpg"
    },
    {
        "title": "全年级覆盖",
        "picture": "../assets/singapore/why4.jpg"
    },
    {
        "title": "灵活的上课时间",
        "picture": "../assets/singapore/why5.jpg"
    },
    {
        "title": "专属贴心的辅导老师",
        "picture": "../assets/singapore/why6.jpg"
    }
]
export const parentsList = [
    {
        "name": "Jenny Wilson",
        "age": " 2021 年起在Sino-bus学习中文",
        "introduce": "Sino-bus 学生和家长的感言",
        "message": "我的儿子从去年夏天开始在 Sino-bus 学习中文。他每周上两节课。虽然他每周有两次作业要做，但他对这些课程没有任何抱怨。他的老师非常有耐心，知识渊博，所以他很喜欢和老师交流。我觉得他的中文进步很大。我们都推荐 Sino-bus 的在线中文课程。",
        'picture': "../assets/singapore/banner6-1.png"
    },
    {
        "name": "sylvia",
        "age": "2021 年起在Sino-bus学习中文",
        "introduce": "Sino-bus 学生和家长的感言",
        "message": "从开始上课到现在，我们的辅导老师Zoe 和周老师都非常棒！她们营造了轻松愉快的氛围，而且非常热情友好！我儿子在新加坡的中文课上玩得非常开心，课后他总是跟我说这门课有多棒！老师真的很有教学天赋，而且非常热爱她的工作。自从开始每周两次的中文课，孩子的中文水平有了显著的提高。",
        'picture': "../assets/singapore/banner6-4.png"
    },
    {
        "name": "frederica",
        "age": " 2021 年起在Sino-bus学习中文",
        "introduce": "Sino-bus 学生和家长的感言",
        "message": "Sino-bus 是一个非常棒的课程，它能高效地帮助孩子的学习！课程内容不仅引人入胜，老师们也充满爱心、热情友好、勤奋敬业。这里是孩子们学习的最佳环境，孩子学习进步明显。Sino-bus 能够提供丰富的资源，帮助孩子们提升阅读、写作和口语能力。我非常满意，强烈推荐 Sino-bus！在新加坡需要学习中文的孩子真的可以试试 Sino-bus。",
        'picture': "../assets/singapore/banner6-6.png"
    }
]
export const teacherDataList = [
    {
        "name": "胡老师 ",
        "quality": "好评率：99%",
        "introduce": "胡老师 毕业于新加坡南洋理工大学，5年教学经验，拥有国际中文教师资格证CTCSOL证书，教学理念以学生为本，让汉语学习变成一件轻松有趣又有收获的事情。",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t11712560362539.jpg?Expires=4866160362&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=RSn5fhkG0xivRFZjqk8gt99sDVU%3D",
        "remark": "线上累计授课时长：3600多节",
        'picture': "../assets/singapore/teacher1.jpg"
    },
    {
        "name": "吴老师",
        "quality": "好评率：100%",
        "introduce": "吴老师 毕业于昆士兰大学，10年教学经验，拥有国际汉语教师证书和国内教师资格证，教学理念是以语言为桥，载文化之美，以真心育人，启成长之智，教学风格生动有趣，敢于创新，课堂氛围活泼。线上累计授课时长：3800小时",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t21712560253307.jpg?Expires=4866160253&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=kspObTHSMHsHWtR%2FosZ5rLT8Fm4%3D",
        "remark": "线上累计授课时长：3800小时",
        'picture': "../assets/singapore/teacher2.jpg"
    },
    {
        "name": "王老师",
        "quality": "好评率：99%",
        "introduce": "王老师 毕业于中国传媒大学，5年教学经验，拥有国际注册对外汉语教师证书和普通话一级乙等证书，教学风格温和、幽默、有耐心、能够根据不同类型的学生转换授课风格，教学理念是活泼有趣的课堂是孩子学习中文的桥梁。",
        "pictureMob": "http://sino-java.oss-cn-shenzhen.aliyuncs.com/2024-04-08/t31712560266656.jpg?Expires=4866160266&OSSAccessKeyId=LTAI5t7JyJTMUGbf7rtfejnV&Signature=SNetUuCbkcLEGzppFpJnQhcGsMA%3D",
        "remark": "线上累计授课时长：3000小时以上",
        'picture': "../assets/singapore/teacher3.jpg"
    }
]